/* eslint-disable no-undef */
import axios from "axios";
import React from "react";
import fetchToken from "./token";

export default class AdminHttpService extends React.Component {
  static async getRequest(token, url, optionalOptions = {}) {
    const authToken = (await fetchToken()) ?? token;

    const BASEURL = process.env.REACT_APP_API_URL;
    const options = {
      ...optionalOptions,
      headers: {
        Authorization: `Bearer ${authToken}`,
        Accept: "application/json",
        CacheControl: "no-cache",
        Pragma: "no-cache",
        Expires: "0"
      }
    };
    return axios
      .get(BASEURL + url, options)
      .then(res => {
        return res.data;
      })
      .catch(error => {
        return { isSuccess: false, message: error.message };
      });
  }

  static async getRequestWithHeader(token, url, optionalOptions = {}) {
    const requestToken = (await fetchToken()) ?? token;

    const BASEURL = process.env.REACT_APP_API_URL;
    const options = {
      ...optionalOptions,
      headers: {
        Authorization: `Bearer ${requestToken}`,
        Accept: "application/json",
        CacheControl: "no-cache",
        Pragma: "no-cache",
        Expires: "0"
      }
    };
    return axios.get(BASEURL + url, options).catch(error => {
      return { error };
    });
  }

  static async postRequest(
    token,
    url,
    body,
    header = { Accept: "application/json" }
  ) {
    const requestToken = (await fetchToken()) ?? token;

    const BASEURL = process.env.REACT_APP_API_URL;
    return axios
      .post(BASEURL + url, body, {
        headers: { ...header, Authorization: `Bearer ${requestToken}` }
      })
      .then(res => {
        return res.data;
      })
      .catch(error => {
        if (error.response?.data) {
          const data = error.response.data;
          return { isSuccess: data.isSuccess, message: data.message };
        }
        return { isSuccess: false, message: error.message };
      });
  }

  static async putRequest(token, url, body, optionalOptions = {}) {
    const requestToken = (await fetchToken()) ?? token;

    const BASEURL = process.env.REACT_APP_API_URL;
    const options = {
      ...optionalOptions,
      headers: {
        Authorization: `Bearer ${requestToken}`,
        Accept: "application/json",
        "Content-Type": "application/json"
      }
    };
    return axios
      .put(BASEURL + url, body, options)
      .then(res => {
        return res.data;
      })
      .catch(error => {
        if (error.response?.data) {
          const data = error.response.data;
          return { isSuccess: data.isSuccess, message: data.message };
        }
        return { isSuccess: false, message: error.message };
      });
  }

  static async patchRequest(token, url, body, optionalOptions = {}) {
    const requestToken = (await fetchToken()) ?? token;

    const BASEURL = process.env.REACT_APP_API_URL;
    const options = {
      ...optionalOptions,
      headers: {
        Authorization: `Bearer ${requestToken}`,
        Accept: "application/json",
        "Content-Type": "application/json"
      }
    };
    return axios
      .patch(BASEURL + url, body, options)
      .then(res => {
        return res.data;
      })
      .catch(error => {
        if (error.response?.data) {
          const data = error.response.data;
          return { isSuccess: data.isSuccess, message: data.message };
        }
        return { isSuccess: false, message: error.message };
      });
  }

  static async deleteRequest(token, url, data = {}) {
    const requestToken = (await fetchToken()) ?? token;

    const BASEURL = process.env.REACT_APP_API_URL;
    return axios
      .delete(BASEURL + url, {
        headers: {
          Authorization: `Bearer ${requestToken}`,
          Accept: "application/json"
        },
        data
      })
      .then(res => {
        return res.data;
      })
      .catch(error => {
        if (error.response?.data) {
          const data = error.response.data;
          return { isSuccess: data.isSuccess, message: data.message };
        }
        return { isSuccess: false, message: error.message };
      });
  }
}
